import { ApiRoutes } from '../helpers/routes'
import { ChatMessage } from '../models/chat'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/chat`

class ChatService {
    sendMessage = async (message: ChatMessage) => {
        return fetchApi(`${baseUrl}${ApiRoutes.chat.sendMessage}`, {
            method: 'POST',
            body: JSON.stringify(message),
        })
    }

    getChat = async (senderId: string, recipientId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.chat.getChat.replace(':senderId', senderId).replace(':recipientId', recipientId)}`,
            {
                method: 'GET',
            },
        )
    }

    getAllChats = async (senderId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.chat.getAllChats.replace(':senderId', senderId)}`, {
            method: 'GET',
        })
    }
}

export default ChatService
